import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import '../style/navi.css'
import logo from '../images/Logo.png'

const Navi = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false)
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <nav className="navbar">
      <div className="logo-text">
        <Link to="/" onClick={() => setMobileMenuOpen(false)}>
          <img src={logo} alt="MTT Ubezpieczenia Logo" className="logo" />
        </Link>
      </div>

      <div className="hamburger" onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}>
        {isMobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
      </div>

      <ul className={`nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
        <li>
          <Link to="/" onClick={() => setMobileMenuOpen(false)}>Strona główna</Link>
        </li>
        <li
          className="dropdown"
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
          onClick={() => setDropdownOpen(!isDropdownOpen)}
        >
          <span className="dropbtn">Ubezpieczenia ▾</span>
          {isDropdownOpen && (
            <ul className="dropdown-content">
              <li>
                <Link to="/ubezpieczenia/komunikacyjne" onClick={() => setMobileMenuOpen(false)}>
                  Ubezpieczenia komunikacyjne
                </Link>
              </li>
              <li>
                <Link to="/ubezpieczenia/majatkowe" onClick={() => setMobileMenuOpen(false)}>
                  Ubezpieczenia majątkowe
                </Link>
              </li>
              <li>
                <Link to="/ubezpieczenia/dla-lekarzy" onClick={() => setMobileMenuOpen(false)}>
                  Ubezpieczenia dla branży medycznej
                </Link>
              </li>
              <li>
                <Link to="/ubezpieczenia/na-zycie" onClick={() => setMobileMenuOpen(false)}>
                  Ubezpieczenia na życie
                </Link>
              </li>
              <li>
                <Link to="/ubezpieczenia/zglos-szkode" onClick={() => setMobileMenuOpen(false)}>
                  Zgłoś szkodę
                </Link>
              </li>
            </ul>
          )}
        </li>
        <li>
          <Link to="/o-nas" onClick={() => setMobileMenuOpen(false)}>O nas</Link>
        </li>
        <li>
          <Link to="/kontakt" onClick={() => setMobileMenuOpen(false)}>Kontakt</Link>
        </li>
      </ul>

      <div className="contact-info">
        <a href="tel:+48666691526" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <PhoneIcon fontSize="small" style={{ color: '#4ECDC4' }} /> +48 666 691 526
        </a>
        <a href="mailto:mtt.ubezpieczenia@gmail.com" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <EmailIcon fontSize="small" style={{ color: '#FF6B6B' }} /> mtt.ubezpieczenia@gmail.com
        </a>
      </div>
    </nav>
  )
}

export default Navi
